import { BaseMark } from '../BaseMark.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'chroaSpathiBelow';
const args = { color: CssVars.ColorFthora };

export class ChroaSpathiBelow extends BaseMark {
  constructor() {
    super(glyphname, args);
  }
}
